import React, { useEffect, useState } from "react";
import {
  createSeparate,
  deleteSeparate,
  getDataItems,
  getSeparate,
} from "../../api/Separates";
import LoadingPage from "../Loading/loading";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";

const ViewSeparatePage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const cookie = new Cookies();

  const [separateData, setSeparateData] = useState(null);
  const [deleteUnit, setDeleteUnit] = useState(false);

  useEffect(() => {
    getSeparate(params.id).then((result) => {
      setSeparateData(result.data.separate);
    });
  }, []);

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  return (
    <div className="main-content">
      {separateData === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form>
            <label htmlFor="image">Images</label>
            <div className="image-previews">
              {separateData.imgs.map((image, imageIndex) => (
                <div key={imageIndex} className="preview-item">
                  <img src={image} alt={`Preview ${imageIndex}`} />
                </div>
              ))}
            </div>

            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="logo">Developer Logo</label>
              <div style={{ position: "relative", marginTop: "16px" }}>
                <div className="preview-item">
                  <img src={separateData.company.logo} alt="logo" />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="Developer name">Developer name</label>
              <input type="text" value={separateData.company.name} disabled />
            </div>

            <div className="form-group">
              <label htmlFor="Title">Title</label>
              <input type="text" value={separateData.project.name} disabled />
            </div>

            <div className="form-group">
              <label htmlFor="Location">Location</label>
              <input type="text" value={separateData.location.name} disabled />
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="downPayment">Down payment</label>
                <input
                  type="number"
                  value={separateData.downPayment}
                  disabled
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="installmentDuration">Years Number</label>
                <input
                  type="number"
                  value={separateData.installmentDuration}
                  disabled
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}>
                <div
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    color: "#555",
                  }}
                >
                  <label htmlFor="Finishing">Finishing</label>
                </div>

                <div style={{ paddingBottom: "10px" }}>
                  {separateData.finishingType.map((finishing) => (
                    <div key={finishing}>
                      <label
                        htmlFor="Down payment"
                        style={{ paddingLeft: "10px" }}
                      >
                        {finishing
                          ?.replaceAll("-", " ")
                          ?.toLowerCase()
                          ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}>
                <div
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    color: "#555",
                  }}
                >
                  <label htmlFor="Delivery">Delivery</label>
                </div>

                {separateData.deliveryStatus.map((delivery) => (
                  <div key={delivery}>
                    <label
                      htmlFor="Down payment"
                      style={{ paddingLeft: "10px" }}
                    >
                      {delivery
                        ?.replaceAll("-", " ")
                        ?.toLowerCase()
                        ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="form-group">
              <div
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "bold",
                  color: "#555",
                }}
              >
                <label htmlFor="Types">Types</label>
              </div>
            </div>

            <label>Villa</label>

            {separateData.project.villas.map((villa, index) => (
              <div key={index}>
                {" "}
                {villa.available && (
                  <div>
                    <label
                      htmlFor={`villa-${index}`}
                      style={{ paddingLeft: "10px", cursor: "pointer" }}
                    >
                      {villa.type
                        ?.replaceAll("-", " ")
                        ?.toLowerCase()
                        ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                    </label>
                    {villa.available && (
                      <div
                        className="choices-container"
                        style={{
                          display: "flex",
                          width: "100%",
                          gap: "15px", // Better than space-between for consistent spacing
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          className="form-group"
                          style={{
                            flex: "1 1 calc(50% - 15px)",
                            minWidth: "250px",
                          }}
                        >
                          <label htmlFor="Price">Price</label>
                          <input type="number" value={villa.price} disabled />
                        </div>
                        <div
                          className="form-group"
                          style={{
                            flex: "1 1 calc(50% - 15px)",
                            minWidth: "250px",
                          }}
                        >
                          <label htmlFor="Area">Area</label>
                          <input type="number" value={villa.area} disabled />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}

            <label>Apartment</label>

            {separateData.project.apartments.map((apartment, index) => (
              <div key={index}>
                {apartment.available && (
                  <div>
                    <label
                      htmlFor={`apartment-${index}`}
                      style={{ paddingLeft: "10px", cursor: "pointer" }}
                    >
                      {apartment.type
                        ?.replaceAll("-", " ")
                        ?.toLowerCase()
                        ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                    </label>
                    {apartment.available && (
                      <div
                        className="choices-container"
                        style={{
                          display: "flex",
                          width: "100%",
                          gap: "15px", // Better than space-between for consistent spacing
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          className="form-group"
                          style={{
                            flex: "1 1 calc(50% - 15px)",
                            minWidth: "250px",
                          }}
                        >
                          <label htmlFor="Price">Price</label>
                          <input
                            type="number"
                            value={apartment.price}
                            disabled
                          />
                        </div>
                        <div
                          className="form-group"
                          style={{
                            flex: "1 1 calc(50% - 15px)",
                            minWidth: "250px",
                          }}
                        >
                          <label htmlFor="Area">Area</label>
                          <input
                            type="number"
                            value={apartment.area}
                            disabled
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea type="text" value={separateData.description} disabled />
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="whatsapp">WhatsApp number</label>
                <input type="text" value={separateData.whatsapp} disabled />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="whatsapp_link">WhatsApp group link</label>
                <input
                  type="text"
                  value={separateData.whatsapp_link}
                  disabled
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="DeveloperCommission">
                  Developer commission %
                </label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    value={separateData.DeveloperCommission}
                    disabled
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="taxes">Taxes %</label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input type="text" value={separateData.taxes} disabled />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="CommissionBroker">Commission broker %</label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    value={separateData.CommissionBroker}
                    disabled
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>

              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="CommissionBrokerOnSpot">
                  Commission broker onSpot %
                </label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    value={separateData.CommissionBrokerOnSpot}
                    disabled
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="CommissionFranchise">
                  Commission franchise %
                </label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    value={separateData.CommissionFranchise}
                    disabled
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>

              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="CommissionFranchiseOnSpot">
                  Commission franchise onSpot %
                </label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    value={separateData.CommissionFranchiseOnSpot}
                    disabled
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>
            </div>

            <div>
              <input
                type="checkbox"
                checked={separateData.available}
                onChange={() => {}}
                disabled
                className="client-checkbox"
              />
              <label htmlFor="Available" style={{ paddingLeft: "10px" }}>
                Available
              </label>
            </div>

            {deleteUnit ? (
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p className="line">
                  Are you sure you want to delete this separate?{" "}
                </p>
                <div className="card-info">
                  <div className="card-actions">
                    <button
                      onClick={() => {
                        setDeleteUnit(false);
                      }}
                      className="action-btn accept-btn"
                    >
                      No
                    </button>
                  </div>
                  <div className="card-actions">
                    <button
                      onClick={() => {
                        deleteSeparate(params.id).then((resullt) => {
                          navigate(-1);
                        });
                      }}
                      className="action-btn remove-btn"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="choices-container"
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "15px", // Better than space-between for consistent spacing
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => {
                    setDeleteUnit(true);
                  }}
                  className="action-btn remove-btn"
                  style={{ width: "45%" }}
                >
                  Delete Separate
                </button>
                <button
                  onClick={() => {
                    navigate(`/update_separate/${separateData._id}`);
                  }}
                  className={`action-btn accept-btn`}
                  style={{ width: "45%" }}
                >
                  Update Separate
                </button>
              </div>
            )}
          </form>
          <ToastContainer />
        </div>
      )}
    </div>
  );
};

export default ViewSeparatePage;
